<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-btn color="primary" @click="addClick">
                    <v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.add') }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card flat outlined>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <TheTable
                                    :additional-filters="documentTypesTable.additionalFilters"
                                    :default-sort="documentTypesTable.defaultSort"
                                    :excel="true"
                                    :fields="documentTypesTable.headers"
                                    :header-selection-key="'document-types-headers'"
                                    :height="documentTypesTable.height"
                                    :total-records="documentTypesTable.total"
                                    :filter-save-key="'document-types-filters'"
                                    @excel="excelExport"
                                    @headers="selectHeaders"
                                    @reload="reloadData"
                                >
                                    <tr
                                        v-for="(item, key) in documentTypesTable.items"
                                        :key="key"
                                        :class="{'cursor-pointer': true}"
                                        @contextmenu.prevent="editClick(props.item.id, true)"
                                    >
                                        <td
                                            v-if="documentTypesTable.selectedHeaders.includes('name')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.name }}
                                        </td>
                                        <td
                                            v-if="documentTypesTable.selectedHeaders.includes('document_category_id')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.document_category_display }}
                                        </td>
                                        <td
                                            v-if="documentTypesTable.selectedHeaders.includes('notify_before')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.notify_before }}
                                        </td>
                                        <td
                                            v-if="documentTypesTable.selectedHeaders.includes('active')"
                                            @click="editClick(item.id, false)"
                                        >
                                            <v-icon v-if="item.active" small>fa-check</v-icon>
                                        </td>
                                        <td>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-btn
                                                        icon
                                                        v-bind="attrs"
                                                        @click="editClick(item.id, true)"
                                                        v-on="on"
                                                    >
                                                        <v-icon small>fa-external-link-alt</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{ $t('tooltips.openInNewTab') }}</span>
                                            </v-tooltip>
                                        </td>
                                    </tr>
                                </TheTable>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import TheTable from './trinkets/TheTable';

export default {
    name: 'DocumentTypes',
    components: {TheTable},
    data: function () {
        return {
            documentTypesTable: {
                selectedHeaders: [],
                headers: [
                    {text: this.$t('fields.name'), value: 'name', type: 'string', allowFilter: true},
                    {
                        text: this.$t('fields.type'),
                        value: 'document_category_id',
                        type: 'dropdown|document-categories',
                        width: '200px',
                        allowFilter: true,
                    },
                    {
                        text: this.$t('fields.notifyBefore'),
                        value: 'notify_before',
                        type: '',
                        width: '150px',
                        allowFilter: true,
                    },
                    {
                        text: this.$t('fields.active'),
                        value: 'active',
                        type: 'boolean',
                        default: null,
                        width: '150px',
                        allowFilter: true,
                    },
                    {text: '', value: 'actions', type: '', sortable: false, width: '100px', allowFilter: false},
                ],
                items: [],
                total: 0,
                lastRequest: null,
                height: '0px',
                defaultSort: {
                    field: 'name',
                    descending: true,
                },
            },
        };
    },
    methods: {
        addClick() {
            this.$router.push('/document-types/0');
        },
        editClick(id, newTab = false) {
            if (!newTab) {
                this.$router.push('/document-types/' + id);
            } else {
                let routeData = this.$router.resolve('/document-types/' + id);
                window.open(routeData.href, '_blank');
            }
        },
        selectHeaders(headers) {
            this.documentTypesTable.selectedHeaders = headers;
        },
        reloadData(request) {
            this.lastRequest = request;
            let vm = this;
            this.$APICall(
                'get',
                'document-types',
                request,
                (data, success) => {
                    if (success) {
                        vm.documentTypesTable.items = data.items;
                        vm.documentTypesTable.total = data.total;
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                false,
            );
        },
        excelExport() {
            let excelRequest = JSON.parse(JSON.stringify(this.lastRequest));
            excelRequest.pagination.itemsPerPage = 999999999;
            excelRequest.pagination.page = 1;

            let vm = this;
            this.$APICall(
                'get',
                'document-types',
                excelRequest,
                (data, success) => {
                    if (success) {
                        vm.$APICall('post', 'excel/document-types', data.items, (data) => {
                            window.open(data.link);
                        });
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                false,
            );
        },
        resolveWindowResize() {
            this.documentTypesTable.height = window.innerHeight - 310 + 'px';
        },
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        this.$myStore.commit('setBreadcrumbs', [
            {text: this.$t('modules.documentTypes'), href: '/#/document-types', disabled: true},
        ]);

        window.addEventListener('resize', this.resolveWindowResize);
        this.resolveWindowResize();
    },
};
</script>

<style scoped></style>
